export enum DropdownDirection {
    /**
     * @description Dropdown direction
     */
    Dropdown = 'dropdown',
    /**
     * @description Dropup direction
     */
    DropUp = 'dropup',
    /**
     * @description Dropstart direction
     */
    DropStart = 'dropstart',
    /**
     * @description Dropend direction
     */
    DropEnd = 'dropend',
    /**
     * @description Dropdown center direction
     */
    DropdownCenter = 'dropdown-center',
    /**
     * @description Dropup center direction
     */
    DropUpCenter = `${DropdownDirection.DropdownCenter} ${DropdownDirection.DropUp}`,
}

/**
 * @description
 * Union type for dropdown direction variants that accepts both enum values and string literals
 * @example
 * ```typescript
 * // Can use enum values
 * @Input() direction: IDropdownDirection = DropdownDirection.Dropdown;
 * 
 * // Can use string literals
 * @Input() direction: IDropdownDirection = 'dropdown';
 * ```
 */
export type DropdownDirectionType = 'dropdown' | 'dropup' | 'dropstart' | 'dropend' | 'dropdown-center' | 'dropup-center' | 'dropdown-center dropup';

/**
 * @description
 * Union type for dropdown direction variants that accepts both enum values and string literals
 * @example
 * ```typescript
 * // Can use enum values
 * @Input() direction: IDropdownDirection = DropdownDirection.Dropdown;
 * ```
 */
export type IDropdownDirection = DropdownDirectionType | DropdownDirection;